angular.module('security', ['security.authService', 'security.restrictAccess']);
